import { NPydantic } from 'SharedDir/declarations/pydantic';

export type ErrorBag = Record<string, Omit<NPydantic.ValidationError, 'loc'>>;

export class PydanticValidationError extends Error {
  details!: ErrorBag;

  constructor(details: ErrorBag) {
    super('Ошибка валидации данных');
    this.details = details;
  }
}
